<!-- 科技成果详情 -->
<template>
  <div class="container">
    <div class="banner"></div>
    <div class="main">
      <div class="content">
        <div class="Breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/achievementLibrary' }"
              >科技成果</el-breadcrumb-item
            >
            <el-breadcrumb-item>详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="box" v-loading="loading">
          <div class="box_header">
            <h1>{{ detailData.name || "-" }}</h1>
            <ul>
              <li>
                发布时间:
                <p>{{ formatDateTime(detailData.create_time) }}</p>
              </li>
              <li>
                联系人:
                <p>{{ detailData.user?.contact || "-" }}</p>
              </li>
              <li>
                联系电话:
                <p>{{ detailData.user?.tel || "-" }}</p>
              </li>
              <li>
                电子邮箱:
                <p>{{ detailData.user?.email || "-" }}</p>
              </li>
            </ul>
          </div>
          <div class="box_main">
            <ul>
              <li>
                <h1>项目名称</h1>
                <p>{{ detailData.name || "-" }}</p>
              </li>
              <li>
                <h1>项目详情</h1>
                <div
                  v-html="formatRichText(detailData.details)"
                  class="fuwenben"
                ></div>
              </li>
              <li>
                <h1>供应方</h1>
                <p>{{ detailData.user?.company || "-" }}</p>
              </li>
              <li>
                <h1>相关专利申请号</h1>
                <div
                  v-html="formatRichText(detailData.about)"
                  class="fuwenben"
                ></div>
              </li>
              <li>
                <h1>研发团队介绍</h1>
                <div
                  v-html="formatRichText(detailData.team)"
                  class="fuwenben"
                ></div>
              </li>
              <li>
                <h1>合作意向说明</h1>
                <div
                  v-html="formatRichText(detailData.cooperate)"
                  class="fuwenben"
                ></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAchievementDetail } from "../api/userApi";

export default {
  data() {
    return {
      loading: false,
      detailData: "",
    };
  },
  created() {
    this.getAchievementDetailData();
  },
  methods: {
    async getAchievementDetailData() {
      this.loading = true;
      try {
        const id = this.$route.query.id;
        if (!id) {
          this.$message.error("缺少ID参数");
          return;
        }

        const response = await getAchievementDetail({ id });
        if (response.code === 1) {
          this.detailData = response.data;
        } else {
          this.$message.error("获取详情失败");
        }
      } catch (error) {
        console.error("获取科技成果详情失败:", error);
        this.$message.error("获取详情失败");
      } finally {
        this.loading = false;
      }
    },

    // 格式化时间为 YYYY-MM-DD HH:mm:ss 格式
    formatDateTime(timestamp) {
      if (!timestamp) return "-";
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 处理富文本内容
    formatRichText(content) {
      if (!content) return "<p>-</p>";
      // 这里可以添加更多的富文本处理逻辑
      return content;
    },
  },
};
</script>

<style scoped lang="less">
li {
  list-style: none;
}
.fuwenben {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #121212;
  text-align: left;
}
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
}
.banner {
  background: url(../assets/banner2.png) no-repeat center/cover;
  width: 100%;
  height: 318px;
}
.main {
  background: #f5f5f5;
  padding-bottom: 45px;
  .Breadcrumb {
    padding: 15px 0;
    ::v-deep .el-breadcrumb__inner {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #121212;
    }
  }
  .box {
    padding: 30px;
    background-color: #fff;
    border-radius: 10px;
    .box_header {
      h1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #0c1223;
        text-align: left;
        margin-bottom: 10px;
      }
      ul {
        display: flex;
        margin-bottom: 30px;
        li {
          display: flex;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #121212;
          margin-right: 35px;
        }
      }
    }
    .box_main {
      ul {
        li {
          border-top: 1px solid #efeded;
          padding-top: 30px;
          margin-bottom: 30px;
          h1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #121212;
            text-align: left;
            margin-bottom: 10px;
          }
          p {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #121212;
            text-align: left;
          }
        }
        li:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
